import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Text } from "~/components-shared";
import lists from "~/lib/lists";
import { useDispatch, useSelector } from "react-redux";
import integrationSelectors from "~/store/integrations/selectors";
import { AuthoritiesEnum, CRUDActionEnum, IntegrationTypeEnum, RequestActionsEnum } from "~/types/enums";
import requestsActionCreators from "~/store/requests/actions";
import eventsActionCreators from "~/store/events/actions";
import authSelectors from "~/store/auth/selectors";
import styled from "styled-components";
import useAbacExt from "~/hooks/abac";
import api from "~/lib/api";
const Actions = styled.div`
  text-align: right;
`;
const RequestActionsCard = _ref => {
  let {
    request,
    reached,
    dateExpired,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(authSelectors.getUser);
  const slackIntegration = useSelector(integrationSelectors.getIntegrationByType(IntegrationTypeEnum.SLACK));
  const dispatch = useDispatch();
  const {
    userHasOneOf
  } = useAbacExt();
  if (!(reached || dateExpired) && userHasOneOf([AuthoritiesEnum.REQUESTS_WRITE], request.createdBy.id) || request.closedAt) {
    return null;
  }
  const handleMeeting = () => {
    dispatch(eventsActionCreators.actionChanged(CRUDActionEnum.CREATE, undefined));
  };
  const handleEmail = () => {
    const recipients = request.volunteers.map(_ref2 => {
      let {
        email
      } = _ref2;
      return email;
    }).filter(email => email === user?.email);
    window.open(`mailto:${recipients.join(",")}?subject=${request.name}`, "_blank");
  };
  const handleSlackChannel = () => {
    api.openRequestSlackConversation(request.id).then(_ref3 => {
      let {
        url
      } = _ref3;
      window.open(url);
    });
  };
  const handleClose = () => {
    dispatch(requestsActionCreators.actionChanged(CRUDActionEnum.CLOSE, request.id));
  };
  const handleUpdate = () => {
    dispatch(requestsActionCreators.actionChanged(CRUDActionEnum.UPDATE, request.id));
  };
  const actions = [{
    type: RequestActionsEnum.MEETING,
    onClick: handleMeeting
  }, {
    type: RequestActionsEnum.EMAIL,
    onClick: handleEmail
  }];
  if (slackIntegration) {
    actions.push({
      type: RequestActionsEnum.SLACK_GROUP,
      onClick: handleSlackChannel
    });
  }
  if (dateExpired) {
    actions.push({
      type: RequestActionsEnum.EXTEND_DATE,
      onClick: handleUpdate
    });
  }
  return /*#__PURE__*/React.createElement(Card, _extends({
    shadow: true
  }, rest), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    s: {
      mb: 2
    }
  }, reached ? t("RequestActionsCard.numberReached") : t("RequestActionsCard.dateExpired")), /*#__PURE__*/React.createElement(Actions, null, actions.map(action => /*#__PURE__*/React.createElement(Button, {
    key: action.type,
    s: {
      ml: 2,
      mt: 3,
      px: 4,
      py: 2
    },
    color: "primary",
    onClick: action.onClick,
    fontSize: 3,
    display: "inline-block",
    rounded: true
  }, lists.requests.actions.names[action.type])), userHasOneOf([AuthoritiesEnum.REQUESTS_WRITE], request?.createdBy.id) && /*#__PURE__*/React.createElement(Button, {
    s: {
      ml: 2,
      mt: 3,
      px: 4,
      py: 2
    },
    color: "grey",
    onClick: handleClose,
    fontSize: 3,
    display: "inline-block",
    rounded: true
  }, t("RequestActionsCard.closeRequest"))));
};
export default RequestActionsCard;